var path = 'src/app/stats/patients-by-group-table.html';
var html = "<div loading=loading> <table class=\"table table-condensed table-striped\"> <thead> <tr> <th>#</th> <th> <span ng-switch=groupType> <span ng-switch-when=HOSPITAL>Hospital</span> <span ng-switch-when=COHORT>Cohort</span> </span> </th> <th>Patients</th> </tr> </thead> <tbody> <tr ng-if=\"counts.length === 0\"> <td colspan=3>No patients.</td> </tr> <tr ng-repeat=\"count in counts\"> <td>{{$index + 1}} </td><td>{{count.group.shortName}}</td> <td>{{count.count}}</td> </tr> </tbody> </table> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/stats/patients-by-group-table.html
 ** module id = 44
 ** module chunks = 0
 **/